export default __webpack_public_path__ + "static/media/banner-law-firms.4aa855fb.png";